module.exports = __webpack_public_path__ + "img/3.ee162144.jpg";